import { usePost } from "hooks/usePost";
import React, { useEffect, useState } from "react";
import { NotificationContainer } from "react-notifications";
import { Form } from "react-router-dom";
import { Button, Card, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Row, Table, UncontrolledDropdown } from "reactstrap";

const BlackList = () => {
  const [status, setStatus] = useState(1);
  const [updateStatus, setUpdateStatus] = useState();
  const { postData, resData, postError, isPending } = usePost();
  const [blackListUsers, setBlackListUsers] = useState([]);
  const [checkList, setCheckList] = useState([])
  const getBlacklistedUser = (status) => {
    setStatus(status)
  }

  useEffect(() => {
    // blacklistPost(`${process.env.REACT_APP_NODE_SERVER}/api/blacklist/addUserInBlackList`,payload,"POST");
    listingApi()
  }, [status])

  const listingApi = () => {
    postData(`${process.env.REACT_APP_NODE_SERVER}/api/blacklist/getBlackListUsers?status=${status}`,[],`GET`);
  }

  useEffect(() => {
    if (!postError && !isPending && resData?.result) {
      setBlackListUsers(resData.result);
      setCheckList([])
      setUpdateStatus(0)
    }
  }, [resData])

  const handleCheckbox = (e,obj) => {
    const isChecked = e.target.checked;
    if(isChecked){
      setCheckList([...checkList,obj.blacklist_id]);
    }else{
      setCheckList(prev => prev.filter(id => id !== obj.blacklist_id));
    }
    setUpdateStatus(1)
  }

  const approveBlackList = async () => {
    const payload = {
      multipleIds:checkList,
      status:updateStatus
    }
    await postData(`${process.env.REACT_APP_NODE_SERVER}/api/blacklist/updateBlackListUser`, payload, 'POST');
    listingApi()
  }

  const addCheckList = async(id) => {
    const data = []
    data.push(id)
    const payload = {
      multipleIds:data,
      status:2
    }
    await postData(`${process.env.REACT_APP_NODE_SERVER}/api/blacklist/updateBlackListUser`, payload, 'POST');
    listingApi()
  }

  return (
    <div className="pt-7">
      <NotificationContainer />
      <Col className="mb-5 mb-xl-0 m-3" xl="11">
      <Button className="mb-5" onClick={()=>getBlacklistedUser(1)}  color={status === 1 ? 'primary' : 'secondary'}>
        BlackListed
      </Button>
      {/* <Button className="mb-5" onClick={()=>getBlacklistedUser(0)} color={status === 0 ? 'primary' : 'secondary'}>
        Guide Request
      </Button> */}
      {checkList.length > 0 &&<Button className="mb-5 mr-0" style={{float:'right'}} onClick={() => approveBlackList()} color={'primary'}>
      Approve BlackList
      </Button>}
        <Card className="shadow mt-3">
          <div className="table-responsive py-4 px-4">
          <Table className="align-items-center table-flush responsive">
              <thead className="thead-light">
                <tr>
                  <th></th>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Contact</th>
                  {status === 1 && (<th scope="col">Last Booking Atempt</th>)}
                  {status === 1 && (<th scope="col">Booking Atempt Count</th>)}
                </tr>
              </thead>
              <tbody>
                {blackListUsers && blackListUsers.map((item,key) => {
                  return (
                    <tr key={key}>
                      <td>
                       { status === 0 &&<FormGroup
                          check
                          inline
                        >
                          <Input type="checkbox" onChange={(e)=>{handleCheckbox(e,item)}}/>
                          <Label check>
                          </Label>
                        </FormGroup>}
                        {status === 1 && <>
                          <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-icon-only text-light"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                          >
                            <i className="fas fa-ellipsis-v" />
                            </DropdownToggle>
                            <DropdownMenu>
                            <DropdownItem
                              onClick={() => addCheckList(item.blacklist_id)}
                            >
                              Revoke User
                            </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </>}
                      </td>
                      <td>{item.name}</td>
                      <td>{item.email}</td>
                      <td>{item.contact}</td>
                      {status === 1 && (<><td>{item.last_booking_attempt}</td>
                      <td>{item.booking_attempt_count}</td></>)}
                    </tr>
                  )
                })}
                {!blackListUsers.length  &&
                  <tr><td colSpan='6' className="text-center">No Data Found!</td></tr>
                }
              </tbody>
            </Table>
         </div>
        </Card>
      </Col>
    </div>
  );
};

export default BlackList;
